// extracted by mini-css-extract-plugin
export default {"headerTitle":"countries_headerTitle__rkGCV","page":"countries_page__tE0w7","header":"countries_header__gqrsM"};